<seal-loading-bar></seal-loading-bar>

@if (isScreenSmall()) {
  <seal-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="navigation().default"
    [opened]="false">
    <ng-container sealVerticalNavigationContentHeader>
      <div class="flex h-20 items-center px-8 pt-6">
        <img class="w-24" alt="" [src]="environment.LOGO_TEXT_DARK" />
      </div>
    </ng-container>

    <ng-container sealVerticalNavigationContentFooter>
      <div class="mb-4 mt-2 flex h-16 flex-0 items-center justify-center px-6 opacity-12">
        <img class="max-w-36" alt="" [src]="environment.LOGO_TEXT_DARK" />
      </div>
    </ng-container>
  </seal-vertical-navigation>
}

<div class="flex w-full min-w-0 flex-auto flex-col">
  <div class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:border-b-slate-500 dark:shadow-none sm:h-20 md:px-6">
    @if (!isScreenSmall()) {
      <div class="mx-2 flex items-center lg:mr-8">
        <div class="hidden lg:flex">
          <img [ngClass]="{ 'h-7': environment.SERVICE_ID !== ServiceEnum.CHEVRON }" class="dark:hidden" alt="" [src]="environment.LOGO_TEXT" />

          <img [ngClass]="{ 'h-7': environment.SERVICE_ID !== ServiceEnum.CHEVRON }" class="hidden dark:flex" alt="" [src]="environment.LOGO_TEXT_DARK" />
        </div>

        <img class="flex w-8 lg:hidden" alt="" [src]="environment.LOGO" />
      </div>

      <!--      <seal-horizontal-navigation class="mr-2" [name]="'mainNavigation'" [navigation]="horizontalNavigation() | navigationVessel"></seal-horizontal-navigation>-->
      <seal-horizontal-navigation class="mr-2" [name]="'mainNavigation'" [navigation]="horizontalNavigation() | navigationVessel"></seal-horizontal-navigation>
    }

    @if (isScreenSmall()) {
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
      </button>
    }

    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      @if (!environment.production) {
        <!-- TODO: COMMENT OUT FOR RELEASE/1.0.10-->
        <!--        <button mat-icon-button matTooltip="check" (click)="checkPasskey()">-->
        <!--          <mat-icon [svgIcon]="'heroicons_outline:check-circle'" aria-label="Key"></mat-icon>-->
        <!--        </button>-->
        <!--        <button mat-icon-button matTooltip="login" (click)="onPasskeyLogin()">-->
        <!--          <mat-icon [svgIcon]="'heroicons_outline:check'" aria-label="Key"></mat-icon>-->
        <!--        </button>-->
        <!--        <button mat-icon-button matTooltip="register" (click)="onPasskeyRegister()">-->
        <!--          <mat-icon [svgIcon]="'heroicons_outline:key'" aria-label="Key"></mat-icon>-->
        <!--        </button>-->
        <download-manager></download-manager>
      }
      <!--      <seal-fullscreen class="hidden md:block" [tooltip]="'button.fullscreen' | transloco"></seal-fullscreen>-->
      @if (!environment.production) {
        <!--        <theme></theme>-->
        <!--        @if (this.remoteConfig()?.language) {-->
        <!--          <language></language>-->
        <!--        }-->

        @if (this.remoteConfig()?.notification) {
          <notification></notification>
        }
      }
      <!--      @if (environment.SERVICE_ID === ServiceEnum.TABUCHI && environment.production) {-->
      <!--        @if (this.remoteConfig()?.language) {-->
      <!--          <language></language>-->
      <!--        }-->
      <!--      }-->

      <profile></profile>
    </div>
  </div>

  <div class="flex w-full flex-auto flex-col">
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>
</div>
